export default __webpack_public_path__ + "static/media/VroomVroom_Cp_background.4c624adc.jpg";